<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      :width="width"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          :color="color"
          :icon="!!icon"
          :small="size === 'small'"
          :x-small="size === 'x-small'"
          :large="size === 'large'"
          :x-large="size === 'x-large'"
        >
          <v-icon v-if="!!icon" :color="color" :size="iconSize || size">{{ icon }}</v-icon>
          <template v-else>{{ button }}</template>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ title }}
        </v-card-title>

        <v-card-text class="px-0 pb-0">
          <v-data-table
            :loading="history.loading"
            :headers="headers"
            :items="history.items"
            :items-per-page="-1"
            hide-default-footer
            fixed-header
            height="420px"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closureHandler"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      env: {},
      entity_id: {},
      headers: {
        default: () => ([
          { text: 'Created', value: 'created', sortable: false },
          { text: 'Operator', value: 'operator', sortable: false },
        ])
      },
      icon: {},
      handler: {},
      size: {},
      iconSize: {},
      color: { default: 'grey' },
      width: { default: 500 },
      button: {},
      title: {},
    },

    data: () => ({
      dialog: false,
      history: {
        loading: false,
        items: []
      }
    }),
    computed: {},

    watch: {
      dialog (val) {
        this.history.items = []
        if (val) {
          this.loadData()
        }
      }
    },

    methods: {
      closureHandler: function () {
        this.dialog = false
      },
      loadData: function () {
        this.history.loading = true

        API.call(`/cms/deploy/history.json`, {
          env: this.env,
          entity_id: this.entity_id,
        }, null, { entity_id: this.entity_id }).then(resp => {
          this.history.items = resp.data || []
          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.history.loading = false
        })

      }
    }

  }
</script>
